<script>
import feather from 'feather-icons';
import ProjectsFilter from './ProjectsFilter.vue';
import ProjectSingle from './ProjectSingle.vue';
import projects from '../../data/projects';

export default {
	components: { ProjectSingle, ProjectsFilter },
	data: () => {
		return {
			projects: projects.sort((a, b) => b.id - a.id), // Sorting projects in descending order
			projectsHeading: 'Projects Portfolio',
			selectedCategory: '',
			searchProject: '',
		};
	},
	computed: {
		// Get the filtered projects
		filteredProjects() {
			let filtered = this.projects;
			
			// Apply search filter
			if (this.searchProject.trim()) {
				const searchTerm = this.searchProject.toLowerCase().trim();
				filtered = filtered.filter(project => 
					project.title.toLowerCase().includes(searchTerm) ||
					project.category.toLowerCase().includes(searchTerm) ||
					project.technologies[0].techs.some(tech => 
						tech.toLowerCase().includes(searchTerm)
					)
				);
			}
			
			// Apply category filter
			if (this.selectedCategory) {
				filtered = filtered.filter(project => 
					project.category === this.selectedCategory
				);
			}
			
			return filtered;
		},
	},
	mounted() {
		feather.replace();
	},
	updated() {
		feather.replace();
	}
};
</script>


<template>
	<!-- Projects grid -->
	<section class="pt-10 sm:pt-14">
		<!-- Projects grid title -->
		<div class="text-center">
			<p
				class="font-general-semibold text-2xl sm:text-5xl font-semibold mb-2"
			>
				{{ projectsHeading }}
			</p>
		</div>

		<!-- Filter and search projects -->
		<div class="mt-10 sm:mt-10">
			<h3
				class="font-general-regular
					text-center 
					text-md
					sm:text-xl
					font-normal
					mb-4
				"
			>
				Search projects by title or filter by category
			</h3>
			<div
				class="
					flex
					justify-between
					border-b border-primary-light
					dark:border-secondary-dark
					pb-3
					gap-2
				"
			>
				<div class="flex justify-between gap-2">
					<div class="relative">
						<span
							class="absolute left-3 top-1/2 transform -translate-y-1/2"
						>
							<i
								data-feather="search"
								class="w-5 h-5"
							></i>
						</span>
						<input
							v-model="searchProject"
							class="font-general-medium pl-12 pr-3 py-2 rounded-lg text-sm sm:text-md border border-white bg-transparent focus:border-red-300 focus:ring-2 focus:ring-red-100"
							id="name"
							name="name"
							type="search"
							required=""
							placeholder="Search projects"
							aria-label="Name"
						/>
					</div>
				</div>
				<ProjectsFilter @filter="selectedCategory = $event" />
			</div>
		</div>

		<!-- Projects grid -->
		<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-6 sm:gap-10">
			<ProjectSingle
				v-for="project in filteredProjects"
				:key="project.id"
				:project="project"
			/>
		</div>

		<!-- No results message -->
		<div v-if="filteredProjects.length === 0" class="text-center mt-10">
			<p class="font-general-medium text-lg">
				No projects found.
			</p>
		</div>
	</section>
</template>

<style scoped></style>
